import { useState } from "react";

const UPLOAD_TOOLTIP_DESIGN_LAB_SESSION_KEY = "design-lab-processing-tooltip-dismissed";

/**
 * Check if tooltip was dismissed in this session
 */
const checkDismissalState = (): boolean => {
  try {
    return sessionStorage.getItem(UPLOAD_TOOLTIP_DESIGN_LAB_SESSION_KEY) === "true";
  } catch {
    return false;
  }
};

type UseProcessingTooltipOptions = {
  shouldShow: boolean;
  enableTooltip?: boolean;
};

export function useProcessingTooltip({
  shouldShow,
  enableTooltip = true
}: UseProcessingTooltipOptions) {
  const [isDismissed, setIsDismissed] = useState(checkDismissalState);

  const showTooltip = enableTooltip && !isDismissed && shouldShow;

  const dismissTooltip = () => {
    setIsDismissed(true);
    try {
      sessionStorage.setItem(UPLOAD_TOOLTIP_DESIGN_LAB_SESSION_KEY, "true");
    } catch {
      // Fallback if sessionStorage is not available - silently fail
    }
  };

  return {
    showTooltip,
    dismissTooltip
  };
}
